module.exports = __webpack_public_path__ + "static/media/EmptyFolder.f9e800c0.png";